'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Analytics


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _planEnquiryAnalyticsService = require('../../plan/planEnquiryAnalyticsService');

var _FormButton = require('../../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _Form = require('../../../../components/form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormInput = require('../../../../components/form/fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _PrimaryErrorMessage = require('../../../../components/form/messages/PrimaryErrorMessage');

var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);

var _CreditCardContainer = require('../../../../components/form/creditCard/CreditCardContainer');

var _CreditCardContainer2 = _interopRequireDefault(_CreditCardContainer);

var _PaymentPlanList = require('./PaymentPlanList');

var _PaymentPlanList2 = _interopRequireDefault(_PaymentPlanList);

var _PaymentSummary = require('./PaymentSummary');

var _PaymentSummary2 = _interopRequireDefault(_PaymentSummary);

var _CouponCode = require('./CouponCode');

var _CouponCode2 = _interopRequireDefault(_CouponCode);

var _userUtil = require('../../../userUtil');

var _stringUtil = require('../../../../../common/utils/stringUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentFormTitle = function PaymentFormTitle(_ref) {
    var currentUser = _ref.currentUser,
        planVolume = _ref.planVolume;

    if ((0, _userUtil.isSubscribed)(currentUser)) {
        return (0, _stringUtil.chooseSingular)(planVolume, _react2.default.createElement(
            'h1',
            null,
            'Update your billing details'
        ), _react2.default.createElement(
            'h1',
            null,
            'Update billing details (',
            planVolume,
            '\xA0people)'
        ));
    }

    return (0, _stringUtil.chooseSingular)(planVolume, _react2.default.createElement(
        'h1',
        null,
        'Professional plan upgrade'
    ), _react2.default.createElement(
        'h1',
        null,
        'Professional upgrade (',
        planVolume,
        '\xA0people)'
    ));
};

PaymentFormTitle.propTypes = {
    currentUser: _propTypes2.default.object,
    planVolume: _propTypes2.default.number
};

var PaymentForm = function PaymentForm(props) {
    var submitInterceptor = props.submitInterceptor,
        currentUser = props.currentUser,
        submitting = props.submitting,
        primaryError = props.primaryError,
        dirtySinceSubmission = props.dirtySinceSubmission;


    var onClick = (0, _userUtil.isSubscribed)(currentUser) ? _lodash.identity : _planEnquiryAnalyticsService.googleAnalyticsIndividualPayment;

    return _react2.default.createElement(
        _Form2.default,
        { onSubmit: submitInterceptor, className: 'PaymentForm' },
        _react2.default.createElement(PaymentFormTitle, props),
        _react2.default.createElement(_FormInput2.default, _extends({}, props, { name: 'prorateDate', type: 'hidden' })),
        _react2.default.createElement(_PaymentPlanList2.default, props),
        _react2.default.createElement(_CreditCardContainer2.default, props),
        _react2.default.createElement(_CouponCode2.default, props),
        _react2.default.createElement(_PaymentSummary2.default, props),
        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
            show: !!primaryError && !dirtySinceSubmission && !submitting }),
        _react2.default.createElement(
            _FormButton2.default,
            { onClickFn: onClick, type: 'submit', className: 'row payment', disabled: submitting },
            (0, _userUtil.isSubscribed)(currentUser) ? 'Save changes' : 'Buy now'
        )
    );
};

PaymentForm.propTypes = {
    currentUser: _propTypes2.default.object,
    submitting: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitInterceptor: _propTypes2.default.func,
    primaryError: _propTypes2.default.object,
    dirtySinceSubmission: _propTypes2.default.bool
};

exports.default = PaymentForm;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/form/PaymentForm.js
// module id = 2059
// module chunks = 0